import { DataSource, HorizontalSpacer, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCarrierInsOnboardingPanel extends Layout {
    horizontalspacer1: HorizontalSpacer;
    labelOnboardingInfo: Label;
    panelOnboardingInfo: Panel;
    sourceCarrierInsControl: DataSource;
    switchAutoApproveCarriers: Switch;
    switchAutoInsOnFile: Switch;
    switchEnableAdvances: Switch;
    switchIncludeInactiveCarriers: Switch;
    switchMonitorCarriers: Switch;
    switchOnboardingCarrierStatus: Switch;
    switchOnboardingInsBasic: Switch;
    switchOnboardingSendCarrier: Switch;
    textboxCarrierAgreement: Textbox;
    textboxFullSync: Textbox;
    textboxImageDirectory: Textbox;
    textboxLastCheck: Textbox;
    textboxOnboardingPassword: Textbox;
    textboxOnboardingServer: Textbox;
    textboxOnboardingUserName: Textbox;
    textboxPacketUrl: Textbox;
    textboxPacketWebsiteUrl: Textbox;
    textboxPort: Textbox;
    textboxSendLoadDataFrequency: Textbox;
}
